// extracted by mini-css-extract-plugin
export default {"budgetRange":"styles__budgetRange__b101ae22d71fd54397d0"};